export default "__VITE_ASSET__BfYEIHaa__"